module.exports = __webpack_public_path__ + "img/c33de3c.jpg";